import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const TeamTierIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M5.806 12.2471C6.23805 11.8947 6.87496 11.9195 7.27769 12.3223L11.6777 16.7223L11.7529 16.8061C12.1053 17.2381 12.0804 17.875 11.6777 18.2777C11.275 18.6805 10.6381 18.7053 10.206 18.3529L10.1222 18.2777L6.49995 14.6555L2.87766 18.2777C2.44808 18.7073 1.75176 18.7073 1.32218 18.2777C0.892605 17.8482 0.892605 17.1519 1.32218 16.7223L5.72221 12.3223L5.806 12.2471Z"
        fill="currentColor"
      />
      <path
        d="M9.79993 9.8C9.79993 11.6225 8.32246 13.1 6.49991 13.1C4.67736 13.1 3.19989 11.6225 3.19989 9.8C3.19989 7.97746 4.67736 6.5 6.49991 6.5C8.32246 6.5 9.79993 7.97746 9.79993 9.8Z"
        fill="var(--cdl-bg-base)"
      />
      <path
        d="M8.69992 9.8C8.69992 8.58497 7.71494 7.6 6.49991 7.6C5.28488 7.6 4.2999 8.58497 4.2999 9.8C4.2999 11.015 5.28488 12 6.49991 12C7.71494 12 8.69992 11.015 8.69992 9.8ZM10.8999 9.8C10.8999 12.2301 8.92998 14.2 6.49991 14.2C4.06984 14.2 2.09988 12.2301 2.09988 9.8C2.09988 7.36995 4.06984 5.4 6.49991 5.4C8.92998 5.4 10.8999 7.36995 10.8999 9.8Z"
        fill="currentColor"
      />
      <path
        d="M17.5 15.3C17.5 14.6925 17.9925 14.2 18.6 14.2C19.2075 14.2 19.7 14.6925 19.7 15.3V21.9C19.7 22.5075 19.2075 23 18.6 23H11.9999C11.3924 23 10.8999 22.5075 10.8999 21.9C10.8999 21.2925 11.3924 20.8 11.9999 20.8H17.5V15.3Z"
        fill="currentColor"
      />
      <path
        d="M19.15 5.4C19.15 7.22254 17.6725 8.7 15.85 8.7C14.0274 8.7 12.5499 7.22254 12.5499 5.4C12.5499 3.57746 14.0274 2.1 15.85 2.1C17.6725 2.1 19.15 3.57746 19.15 5.4Z"
        fill="var(--cdl-accent-fg-base)"
      />
      <path
        d="M18.05 5.4C18.05 4.18497 17.065 3.2 15.85 3.2C14.6349 3.2 13.6499 4.18497 13.6499 5.4C13.6499 6.61503 14.6349 7.6 15.85 7.6C17.065 7.6 18.05 6.61503 18.05 5.4ZM20.25 5.4C20.25 7.83005 18.28 9.8 15.85 9.8C13.4199 9.8 11.4499 7.83005 11.4499 5.4C11.4499 2.96995 13.4199 1 15.85 1C18.28 1 20.25 2.96995 20.25 5.4Z"
        fill="var(--cdl-accent-fg-base)"
      />
      <path
        d="M21.9 15.3C21.9 17.1225 20.4225 18.6 18.6 18.6C16.7774 18.6 15.3 17.1225 15.3 15.3C15.3 13.4775 16.7774 12 18.6 12C20.4225 12 21.9 13.4775 21.9 15.3Z"
        fill="var(--cdl-bg-base)"
      />
      <path
        d="M20.8 15.3C20.8 14.085 19.815 13.1 18.6 13.1C17.3849 13.1 16.4 14.085 16.4 15.3C16.4 16.515 17.3849 17.5 18.6 17.5C19.815 17.5 20.8 16.515 20.8 15.3ZM23 15.3C23 17.7301 21.03 19.7 18.6 19.7C16.1699 19.7 14.2 17.7301 14.2 15.3C14.2 12.8699 16.1699 10.9 18.6 10.9C21.03 10.9 23 12.8699 23 15.3Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TeamTierIcon;
